module.exports = __webpack_public_path__ + "media/images/icon/blue/ico_angle_left-ef43c33d4fcb22c21a22ef24b78be689.svg";